<template lang="pug">
v-menu(
  ref="menu"
  v-model="datePickerMenu"
  :close-on-content-click="false"
  transition="scale-transition"
  offset-y
  min-width="290px"
)
  template(v-slot:activator="{ on }")
    v-text-field(
      :value="formattedValue"
      :label="label"
      :append-icon="appendIcon"
      readonly
      v-on="on"
      :error="error"
      :error-messages="errorMessages"
      :rules="rules"
      @click:append="appendClickHandler"
    )
  .date-picker-wrapper
    v-date-picker(
      v-if="!time"
      v-model="localValue"
      no-title
      scrollable
      @change="updateValue"
      :range="range"
    )
    v-time-picker(
      v-if="time"
      format="24hr"
      v-model="localValue"
      @change="updateValue"
    )
    .buttons
      v-btn(
        small
        color='error'
        outlined
        @click="cancel"
      ) Cancel
      v-btn(
        small
        color='primary'
        outlined
        @click="accept"
      ) Accept
</template>
<script>
export default {
  props: {
    label: String,
    value: [String, Number, Array],
    rules: Array,
    error: Boolean,
    errorMessages: String,
    range: {
      type: Boolean,
      default: false,
    },
    time: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    appendIcon() {
      if (!this.emptyValue) return 'mdi-close';
      return this.time ? 'mdi-clock-outline' : 'mdi-calendar';
    },
    formattedValue() {
      if (Array.isArray(this.value)) {
        const arrWithoutNull = this.value.filter(val => val);
        return arrWithoutNull.join(' ~ ');
      }
      return [this.value];
    },
    emptyValue() {
      if (this.range && Array.isArray(this.value)) {
        return this.value.every(el => el === undefined);
      }
      return !!this.localValue;
    }
  },
  watch: {
    value() {
      this.$emit('change');
    },
  },
  data: () => ({
    datePickerMenu: false,
    localValue: null,
  }),
  mounted() {
    this.setTodayDate();
  },
  methods: {
    cancel() {
      this.setTodayDate();
      this.datePickerMenu = false;
    },
    accept() {
      if (this.range) {
        if (!this.localValue.length) return;
        const values = this.localValue.length === 1 ? [this.localValue[0], this.localValue[0]] : this.localValue;
        this.$emit('input', values);
      } else {
        this.$emit('input', this.localValue);
      }
      this.datePickerMenu = false;
    },
    appendClickHandler() {
      if (!this.emptyValue) {
        this.clearValue()
      } else {
        this.datePickerMenu = true;
      }
    },
    clearValue() {
      if (this.range) {
        this.localValue = [undefined,undefined];
      } else {
        this.localValue = undefined;
      }
      if (this.value) this.$emit('input', this.localValue);
    },
    setTodayDate() {
      this.localValue = this.value;
    },
    updateValue(val) {
      this.$refs.menu.save(this.localValue)
      this.$emit('input', this.localValue);
    }
  }
}
</script>

<style lang="scss" scoped>

.date-picker-wrapper{
  background-color: white;
  padding: 16px 0;

  ::v-deep {
    .v-card{
      box-shadow: none;
    }
  }

  .buttons{
    text-align: right;
    padding: 0 16px;

    button{
      margin-left: 8px;
    }
  }
}

</style>
